<template>
  <div class="app-content content px-1 py-2">
    <div class="content-wrapper">
      <template v-if="isSupervisor === true">
        <backToDashboard></backToDashboard>
        SETTINGS SUPERVISOR
      </template>
      <template v-else>
        <backToDashboard></backToDashboard>
          <div class="content-header row">
            <div class="content-header-left col-md-4 col-12 mb-2">
              <h2 class="content-header-title mt-4 mb-0 d-inline-block">
                {{ $t('my_parameters') }}
              </h2>
              <fieldset class="mt-2 form-group position-relative" v-if="isSupervisor == 'supervisor'">
                  <select class="form-control" id="DefaultSelect" v-on:change="goToAgentSettings">
                  <option selected>Mes paramètres</option>
                  <option>Paramètres agent</option>
                  </select>
              </fieldset>
            </div>
          </div>
          <div class="content-body">
            <section>
              <div class="row">
                <div class="col-md-3">
                  <div class="card">
                    <div class="text-center">
                      <div class="card-body">
                        <upload :url=url :acceptedFileTypes=acceptedFileTypes
                          :maxFileSize=maxFileSize
                          :postUploadHandler=postUploadHandler>
                            <template slot="preview">
                              <template v-if="settings.avatar">
                                <img :src="settings.avatar"
                                  class="rounded-circle max-height-200" >
                              </template>
                              <template v-else>
                                <div class="rounded-circle max-height-200 default-avatar">
                                  150x150
                                </div>
                              </template>
                            </template>
                          </upload>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-9">
                  <div class="card">
                    <div class="card-content">
                      <div class="card-body">
                        <form v-on:submit.prevent="handleSubmit">
                          <fieldset class="form-group">
                            <input type="text" class="form-control"
                                   id="text" :placeholder="$t('firstname')"
                                   v-model="settings.first_name"
                                   v-on:keyup.enter="handleSubmit"
                                   v-on:blur="handleSubmit">
                          </fieldset>
                          <fieldset class="form-group">
                            <input type="text" class="form-control"
                                   id="text" :placeholder="$t('lastname')"
                                   v-model="settings.last_name"
                                   v-on:keyup.enter="handleSubmit"
                                   v-on:blur="handleSubmit" >
                          </fieldset>
                          <hr class="my-2">
                          <p>
                            <strong>{{ $t('email_address') }}</strong>
                            {{ settings.email }}
                          </p>
                          <p>
                            <strong>{{ $t('skills') }}</strong>
                            {{ settings.skills|joinListByComma }}
                          </p>
                          <p>
                            <strong>{{ $t('kind') }}</strong>
                            {{ $t(settings.kind) }}
                          </p>
                          <p>
                            <strong>{{ $t('last_login') }}</strong>
                            {{ settings.last_login | formatLongDatetime }}
                          </p>
                          <p>
                            <strong>{{ $t('max_rooms') }}</strong>
                            {{ settings.max_rooms }}
                          </p>
                          <hr class="my-2">
                          <h3 class="info">
                            <strong>{{ $t('notifications_title') }}</strong>
                          </h3>
                          <fieldset class="checkbox mt-2">
                            <label>
                              <input type="checkbox" name="want_notif"
                                     v-model="settings.want_notif" >
                              {{ $t('want_notifications_label') }}
                            </label>
                          </fieldset>
                          <fieldset class="checkbox">
                            <label>
                              <input type="checkbox" name="want_daily_report"
                                     v-model="settings.want_daily_report" >
                              {{ $t('want_daily_reports_label') }}
                            </label>
                          </fieldset>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
      </template>
    </div>
  </div>
</template>

<script>
import backToDashboard from '../components/layout/backToDashboard.vue'
import config from '../config/index'
import Upload from '../components/utils/upload'

export default {
  components: {
    'backToDashboard': backToDashboard,
    'Upload': Upload
  },
  computed: {
    acceptedFileTypes () {
      return 'image/gif, image/jpeg, image/png'
    },
    host () {
      return window.location.protocol + '//' + window.location.host
    },
    isSupervisor () {
      return this.$store.getters.getOwnSettings.kind
    },
    maxFileSize () {
      return 50000
    },
    settings () {
      if (this.isSupervisor === true) {
        return this.$store.getters.getOwnSettings
      } else {
        return this.$store.getters.getOwnSettings
      }
    },
    url () {
      return `${config.serverHttp}/agents/settings/upload/`
    }
  },
  filters: {
    joinListByComma (list) {
      let res = []
      list.forEach(function (item) {
        res.push(item.label)
      })
      return res.join(', ')
    }
  },
  methods: {
    goToAgentSettings () {
      this.$router.push({
        path: '/parameters'
      })
    },
    handleSubmit () {
      const data = {
        cmd: 'settings',
        update: this.settings
      }
      this.$socket.send(data)
    },
    postUploadHandler (params) {
      this.settings.avatar = params.file
    }
  },
  watch: {
    'settings.want_notif' (newValue, oldValue) {
      this.handleSubmit()
    },
    'settings.want_daily_report' (newValue, oldValue) {
      this.handleSubmit()
    }
  },
  beforeMount () {
    this.$moment.locale(navigator.language)
    this.$socket.getOwnSettings()
  }
}
</script>

<style lang="scss" scoped>
.default-avatar {
  background: #dedede;
  color: silver;
  padding-top: 55px;
  width: 150px;
}

</style>
